import { normalizeBaseUrl } from './environment.utils';

export const environment = {
  production: true,
  apiAdmin: normalizeBaseUrl('PLACEHOLDER_API_ADMIN_URL'),
  api: normalizeBaseUrl('PLACEHOLDER_API_FOLHA_URL'),
  ws: normalizeBaseUrl('PLACEHOLDER_WS_FOLHA_URL')
};
